module.exports = __webpack_public_path__ + "static/img_yx.32e1ebd7.png";